import React, { useEffect, useState } from 'react';

const SplashScreen = ({ isVisible }) => {
    const [render, setRender] = useState(isVisible);

    useEffect(() => {
        if (isVisible) setRender(true);
    }, [isVisible]);

    const onAnimationEnd = () => {
        if (!isVisible) setRender(false);
    };

    if (!render) return null;

    return (
        <div
            className={`fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-[#2C3E30] transition-opacity duration-500 ease-in-out font-sans overflow-hidden ${!isVisible ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
            onTransitionEnd={onAnimationEnd}
        >
            {/* Background Effects */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#354F38] via-[#2C3E30] to-[#141b16] opacity-90"></div>
            <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 mix-blend-overlay"></div>

            {/* Glowing Orbs */}
            <div className={`absolute top-1/4 left-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-3xl animate-pulse ${!isVisible ? 'opacity-0' : ''}`}></div>
            <div className={`absolute bottom-1/4 right-1/4 w-80 h-80 bg-emerald-500/10 rounded-full blur-3xl animate-pulse delay-700 ${!isVisible ? 'opacity-0' : ''}`}></div>

            <div className="relative z-10 flex flex-col items-center">
                {/* Logo with breathing effect */}
                <div className={`mb-8 relative transition-all duration-700 transform ${isVisible ? 'scale-100 opacity-100 translate-y-0' : 'scale-90 opacity-0 translate-y-10'}`}>
                    <div className="w-32 h-32 bg-white/10 backdrop-blur-md rounded-[2.5rem] flex items-center justify-center border border-white/20 shadow-2xl shadow-black/20 animate-pulse-slow">
                        <img
                            src="/logo192.png"
                            alt="Logo"
                            className="w-20 h-20 object-contain drop-shadow-md"
                        />
                    </div>
                    {/* Ring Accents */}
                    <div className="absolute -inset-4 border border-white/5 rounded-[3.5rem] animate-spin-slow"></div>
                    <div className="absolute -inset-1 border border-white/10 rounded-[2.8rem]"></div>
                </div>

                {/* Typography: Staggered Fade In */}
                <h1 className="text-5xl md:text-6xl font-black text-white tracking-tight mb-4 font-do-hyeon overflow-hidden relative">
                    <span className={`inline-block transition-all duration-700 delay-100 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                        The
                    </span>
                    <span className="inline-block w-4"></span>
                    <span className={`inline-block transition-all duration-700 delay-200 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                        STAFF
                    </span>
                    {/* Shine effect */}
                    <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 translate-x-[-150%] animate-shine"></div>
                </h1>

                {/* Slogan */}
                <div className={`overflow-hidden`}>
                    <p className={`text-white/60 text-lg md:text-xl font-medium tracking-wide transition-all duration-700 delay-400 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        당신의 사역을 지탱합니다
                    </p>
                </div>

                {/* Loading Indicator (Subtle) */}
                <div className={`mt-16 transition-opacity duration-500 delay-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                    <div className="flex space-x-2">
                        <div className="w-2 h-2 bg-white/50 rounded-full animate-bounce"></div>
                        <div className="w-2 h-2 bg-white/50 rounded-full animate-bounce delay-200"></div>
                        <div className="w-2 h-2 bg-white/50 rounded-full animate-bounce delay-500"></div>
                    </div>
                </div>
            </div>

            {/* Version */}
            <div className={`absolute bottom-8 transition-opacity duration-700 delay-500 ${isVisible ? 'opacity-30' : 'opacity-0'}`}>
                <span className="text-white text-xs font-mono">Ver 1.0.0</span>
            </div>
        </div>
    );
};

export default SplashScreen;
